import { map, size } from "lodash";
import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import { arrayWithNEmptyItems } from "../../../../utils/array";
import { formatMonetary, formatUpperCase } from "../../../../utils/formats";
import { Label, Text } from "../styles";

const AgregadosSection = (props) => {
  const { aggregatesLoading, aggregates } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {size(aggregates) == 0 && !aggregatesLoading && (
            <Text>PROPOSTA SEM AGREGADOS.</Text>
          )}
          {(size(aggregates) > 0 || aggregatesLoading) && (
            <Grid container spacing={1}>
              <Grid item md={8}>
                <Label marginBottom={3.3}>Descrição</Label>
              </Grid>
              <Grid item md={4}>
                <Label marginBottom={3.3}>Valor</Label>
              </Grid>
            </Grid>
          )}
          <Grid container spacing={1}>
            {map(
              aggregatesLoading ? arrayWithNEmptyItems(3) : aggregates,
              (item) => (
                <>
                  <Grid item md={8}>
                    <Input
                      loading={aggregatesLoading}
                      value={formatUpperCase(item.descricao)}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <Input
                      loading={aggregatesLoading}
                      value={formatMonetary(item.valor)}
                    />
                  </Grid>
                </>
              )
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AgregadosSection;
